import { Component } from './Confirmation.component'
import { ContextProvider, useConfirmation } from './Confirmation.context'

export const Confirmation = {
  Component: Component,
  Hook: useConfirmation,
  Provider: ContextProvider,
}
